<template>
	<Form ref="formValidate" :model="formValidate"  :label-width="110":label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="投放渠道" prop="appStoreId">
				<Select v-model="formValidate.appStoreId" clearable >
					<Option v-for="item in appStores" :value="item.id" :key="item.id">{{item.storeName}}</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="广告名称">
				<Input v-model="formValidate.advertName" clearable/>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="广告key">
				<Input v-model="formValidate.advertKey" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="广告类型" prop="advertType">
				<Select v-model="formValidate.advertType"clearable>
					<Option v-for="item in advetTypes" :value="item.value" :key="item.value">{{ item.name }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="状态">
				<Select v-model="formValidate.status" clearable>
					<Option value="1">启用</Option>
					<Option value="0">停用</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="创建日期" prop="dateRange">
				<DatePicker type="daterange" v-model="formValidate.dateRange" :options="dateRangeOptions"
					format="yyyy/MM/dd" placement="bottom-end" placeholder="请选择" clearable/>
			</FormItem>
			</Col>
			<Col :md="10" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search"style="margin: 0 8px 16px 16px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
				<Button type="success" @click="exportExcel" icon="ios-cloud-download-outline" style="margin: 0 8px 16px 16px;">导出数据</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>
</template>
<script>
	import api from '../../api'
	import { mapGetters } from 'vuex'
	import { STATISTICS_START_TIME, LINK_TYPES, ADVERT_TYPES } from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {
			showPageStatus: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				appStores: [],
				linkTypes: LINK_TYPES,
				advetTypes: ADVERT_TYPES,
				formValidate: {
					appStoreId: '',
					advertName:'',
					advertKey:'',
					advertType: '',
					status: '',
					dateRange: [],
				},
				dateRangeOptions: {
					//当前日期之后日期为禁选日期
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {
			this.getAllAppStore()
		},
		methods: {
			getAllAppStore() {
				api.statistics
					.getAllUsedStores()
					.then(res => {
						this.appStores = res.data
					})
			},
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			exportExcel(){
				this.$emit('exportExcel', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				this.formSubmit()
			},
			getFormData() {
				const formData = { ...this.formValidate }
				return formData
			}
		}
	}
</script>
